// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import DynamicDropdownPresentationPropsDefault from "@insite/mobius/DynamicDropdown/presentationProps";
import { IconWrapper } from "@insite/mobius/Icon";
import { fontConfig } from "@synd/XDL/PreStyle/typography";
import { xBaseTheme } from "@synd/XDL/types";
import { color, getSystemColor, styledScrollbar } from "@synd/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...DynamicDropdownPresentationPropsDefault,
        mergeCss: true,
        cssOverrides: {
            list: css`
                width: 100%;
                transform: translate(0, -4px);
                border: 1px solid ${color("common.border")};
                box-shadow: inset 0 1px 0 0 ${color("common.black", 0.1)};
                border-radius: 8px;
                ${styledScrollbar({ width: 8, margined: 4 })}
            `,
            dropdownWrapper: css`
                ${({ showSearchIcon }: any) =>
                    !showSearchIcon &&
                    `input[aria-expanded="true"] ~ .clickable-wrapper > ${IconWrapper} {
                        transform: rotate(180deg);
                    }
                    
                `}
                input ~ .clickable-wrapper {
                    height: 100%;
                    pointer-events: none;
                }
                input ~ .clickable-wrapper button {
                    pointer-events: auto;
                }
                input:not(:disabled):hover ~ .clickable-wrapper ${IconWrapper} {
                    color: ${color("common.ui9")};
                }
                input[disabled] ~ .clickable-wrapper ${IconWrapper} {
                    opacity: 0.33;
                }
            `,
            option: css`
                font-size: ${fontConfig.xSmall.size}px;
                line-height: ${fontConfig.xSmall.lineHeight};
                font-weight: ${fontConfig.weight.regular};
                letter-spacing: 0;
                color: ${color("text")};
                background: ${color("common.white")};
                padding: 8px 16px;
                &:hover {
                    background: ${color("common.ui10")};
                    color: ${color("common.white")};
                }
                &[disabled],
                &[disabled] ~ .clickable-wrapper ${IconWrapper} {
                    opacity: 0.33;
                }
            `,
        },
        iconProps: {
            width: 11,
            height: 13,
            css: css`
                &&& {
                    background-color: transparent;
                    display: flex;
                    justify-content: flex-end;
                    position: relative;
                    padding: 0;
                    top: 0;
                    height: 100%;

                    ${({ showSearchIcon }: any) =>
                    showSearchIcon
                        ? `
                        color: ${getSystemColor("common.ui9")};
                        cursor: pointer;
                        pointer-events: unset;
                        width: 16px;
                       
                        svg {
                            width: 14px;
                            height: 14px; 
                        }
                        &:hover{
                            color:${getSystemColor("common.ui10")}
                        }`
                        : `
                        color: ${getSystemColor("common.ui7")};
                        width: auto;`}
                }
            `,
        },
    },
} as xBaseTheme["dynamicDropdown"];
